export function createMockHttpClient(response, shouldFail = false, error, mockOpts) {
    return (apiUrl, opts) => {
        return new Promise((resolve, reject) => {
            if (shouldFail) {
                reject(new Error(error));
            }
            setTimeout(() => {
                resolve(response);
            }, (mockOpts === null || mockOpts === void 0 ? void 0 : mockOpts.delay) || 0);
        }).catch((e) => e);
    };
}
